<mat-icon
  *ngIf="gatewayStore.isAnyClimateSensorDischarged(room) | async"
  class="warning-icon"
  matTooltip="{{ '+INSTALLATIONS.INSTALLATION.SRC.TOOLTIP.CS_BATTERY_LOW' | translate }}"
>
  error_outline
</mat-icon>
<mat-icon
  *ngIf="gatewayStore.isAnyRadiatorValveDischarged(room) | async"
  class="warning-icon"
  matTooltip="{{ '+INSTALLATIONS.INSTALLATION.SRC.TOOLTIP.TRV_BATTERY_LOW' | translate }}"
>
  error_outline
</mat-icon>
<mat-icon
  *ngIf="gatewayStore.isAnyRadiatorValveDisconnected(room) | async"
  class="warning-icon"
  matTooltip="{{ '+INSTALLATIONS.INSTALLATION.SRC.TOOLTIP.TRV_DISCONNECTED' | translate }}"
>
  error_outline
</mat-icon>

<mat-icon
  *ngIf="gatewayStore.isAnyAirQualitySensorDischarged(room) | async"
  class="warning-icon"
  matTooltip="{{
    '+INSTALLATIONS.INSTALLATION.SRC.TOOLTIP.AIR_QUALITY_SENSOR_BATTERY_LOW' | translate
  }}"
>
  error_outline
</mat-icon>
<ng-container
  *ngIf="gatewayStore.isCSOrCo2SensorNotAvailableWithFHT(room) | async as disconnectFHT"
>
  <mat-icon
    *ngIf="disconnectFHT.allDevicesDisconnected"
    class="warning-icon"
    matTooltip="{{
      '+COMMISSIONING.ROOM_INDICATOR.CS_OR_CO2_SENSEOR_NOT_AVAILABLE_WITH_FHT.TITLE' | translate
    }}"
  >
    error_outline
  </mat-icon>
  <mat-icon
    *ngIf="disconnectFHT.isAnyCsDisconnected"
    class="warning-icon"
    matTooltip="{{ '+COMMISSIONING.ROOM_INDICATOR.CS_SENSOR_DISCONNECTED.TITLE' | translate }}"
  >
    error_outline
  </mat-icon>
  <mat-icon
    *ngIf="disconnectFHT.isAnyCo2Disconnected"
    class="warning-icon"
    matTooltip="{{ '+COMMISSIONING.ROOM_INDICATOR.CO2_SENSOR_DISCONNECTED.TITLE' | translate }}"
  >
    error_outline
  </mat-icon>
</ng-container>
<mat-icon
  *ngIf="gatewayStore.isMountingModeActive(room) | async"
  class="warning-icon"
  matTooltip="{{ '+COMMISSIONING.ROOM_INDICATOR.MOUNTING_MODE_WARNING.TITLE' | translate }}"
>
  error_outline
</mat-icon>
<mat-icon
  *ngIf="gatewayStore.isMainFHTUnitDisconnected(room) | async"
  class="warning-icon"
  matTooltip="{{
    '+COMMISSIONING.ROOM_INDICATOR.DISCONNECTED_MAIN_FHT_UNIT_WARNING.TITLE' | translate
  }}"
>
  error_outline
</mat-icon>

<ng-container *ngIf="isUnAssignablePanel">
  <mat-icon
    *ngIf="unassignableDeviceStatus?.isRepeaterDisconnected"
    class="warning-icon"
    matTooltip="{{
      '+COMMISSIONING.ROOM_INDICATOR.DISCONNECTED_MAIN_RANGE_EXTENDER_WARNING.TITLE' | translate
    }}
    "
  >
    error_outline
  </mat-icon>
  <mat-icon
    *ngIf="unassignableDeviceStatus?.isFhtDisconnected"
    class="warning-icon"
    matTooltip="{{
      '+COMMISSIONING.ROOM_INDICATOR.DISCONNECTED_MAIN_FHT_UNIT_WARNING.TITLE' | translate
    }}
    "
  >
    error_outline
  </mat-icon>
</ng-container>

<ng-container *ngIf="gatewayStore.getHeatOnTimeFeature(room) | async as heatOnTime">
  <div class="heat-badge">
    <ng-container *ngIf="!heatOnTime.properties.active.value; else heatOneTimeEnabled">
      <app-pill [type]="pillType.secondary">{{
        '+SRC.OPERATING_STATE.MODIFIER.HEAT_ON_TIME_DISABLED' | translate
      }}</app-pill>
    </ng-container>
    <ng-template #heatOneTimeEnabled>
      <app-pill [type]="pillType.success">{{
        '+SRC.OPERATING_STATE.MODIFIER.HEAT_ON_TIME_ENABLED' | translate
      }}</app-pill>
    </ng-template>
  </div>
</ng-container>
